import React from 'react';
import {
  Drawer,
  DrawerBody,
  DrawerContent,
  DrawerHeader,
  DrawerOverlay,
} from '@tapresearch/ui/components';
import { Accordion } from '@chakra-ui/react';

import { useGetQualificationsWithAnswers } from '../../../../api/QualificationAPI';
import { MultipleSkeletonLoader } from '../../../common/MultipleSkeletonLoader';
import { FilterAccordionItem } from '../../../common/Filter/FilterAccordionItem';
import { QualificationSelector } from './QualificationSelector';

export interface LongitudinalFilterDrawerProps {
  isOpen?: boolean;
  countryId: string;
  languageId: string;
  onClose?: () => void;
}

export function LongitudinalFilterDrawer({
  isOpen = false,
  countryId,
  languageId,
  onClose = () => {
    //
  },
}: LongitudinalFilterDrawerProps) {
  const { data, isLoading } = useGetQualificationsWithAnswers(
    countryId,
    languageId
  );

  return (
    <Drawer size="md" isOpen={isOpen} onClose={onClose}>
      <DrawerOverlay />
      <DrawerContent>
        <DrawerHeader paddingY="8" paddingX="6">
          Data filters
        </DrawerHeader>
        <DrawerBody padding="0" data-testid="longitudinal-filter-drawer-body">
          {isLoading && <MultipleSkeletonLoader numItems={6} />}

          {!isLoading && (
            <Accordion allowMultiple>
              {data.map((qualification) => (
                <FilterAccordionItem
                  filterName={qualification.id}
                  key={qualification.id}
                  title={qualification.attributes.name}
                >
                  <QualificationSelector qualification={qualification} />
                </FilterAccordionItem>
              ))}
            </Accordion>
          )}
        </DrawerBody>
      </DrawerContent>
    </Drawer>
  );
}
